import 'jquery';
import Swiper, { Autoplay, Navigation } from 'swiper';

Swiper.use([Autoplay, Navigation]);

const navigation = (el) => {
  const swiperClass = {
    nextEl: '.' + el + '-swiper__button--next',
    prevEl: '.' + el + '-swiper__button--prev',
  };
  return swiperClass;
};

$(window).on('load', function () {
  new Swiper('.video-swiper', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    navigation: navigation('videos'),
  });

  new Swiper('.dealer-swiper', {
    // loop: true,
    slidesPerView: 3,
    slidesPerColumn: 3,
    slidesPerColumnFill: 'row',
    observer: true,
    observeParents: true,
    navigation: navigation('dealer'),
    breakpoints: {
      576: {
        slidesPerView: 3,
        slidesPerColumn: 3,
      },
      0: {
        slidesPerView: 2,
        slidesPerColumn: 2,
      },
    },
  });
  new Swiper('.review-swiper', {
    loop: true,
    // loop: false, // temp omdat ze 1 review hebben
    // allowTouchMove: false, // temp omdat ze 1 review hebben
    // allowSlideNext: false, // temp omdat ze 1 review hebben
    // allowSlidePrev: false, // temp omdat ze 1 review hebben
    slidesPerView: 2,
    observer: true,
    observeParents: true,
    navigation: navigation('review'),
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
  new Swiper('.soorten-swiper', {
    loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    navigation: navigation('soorten'),
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  });
  new Swiper('.content-swiper', {
    // loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    navigation: navigation('content'),
    breakpoints: {
      767: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  });
  new Swiper('.gallery-swiper', {
    slidesPerView: 'auto',
    // centeredSlides: true,
    spaceBetween: 30,
    navigation: navigation('gallery'),
    breakpoints: {
      767: {
        slidesPerView: 'auto',
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
  });
});
